import React from 'react'
import * as Sentry from '@sentry/nextjs'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import { useTranslation } from 'next-i18next'

interface AppProps {
  children: JSX.Element | JSX.Element[]
}

interface FallbackProps {
  error: Error
  componentStack: string | null
  resetError(): void
}

function FallBack({ resetError }: FallbackProps): JSX.Element {
  const { t } = useTranslation('common')

  return (
    <Box display="flex" alignItems="center" justifyContent="center">
      <Typography>{t('errorBoundary.errorMessage')}</Typography>
      <Button onClick={resetError}>{t('errorBoundary.actionLabel')}</Button>
    </Box>
  )
}

function App({ children }: AppProps): JSX.Element {
  return <Sentry.ErrorBoundary fallback={FallBack}>{children}</Sentry.ErrorBoundary>
}

export default App
